var map = {
	"./pagination-CO2.svg": "9997",
	"./pagination-CO2Activated.svg": "96e2",
	"./pagination-energySavings.svg": "6d47",
	"./pagination-energySavingsActivated.svg": "42d2",
	"./pagination-waterSavings.svg": "aa25",
	"./pagination-waterSavingsActivated.svg": "b7cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dca4";